import { render, staticRenderFns } from "./PaymentMethodFormSelect.vue?vue&type=template&id=b2b1603c&scoped=true&"
import script from "./PaymentMethodFormSelect.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodFormSelect.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodFormSelect.vue?vue&type=style&index=0&id=b2b1603c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b1603c",
  null
  
)

export default component.exports